import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import App from "./App";
import theme from "./theme";
import "./css/tailwind.css";
import "./css/calculator.css";
import "./css/index.scss";
import "shared/logging";

const rootNode = document.getElementById("root");
const root = createRoot(rootNode);
root.render(
    <ThemeProvider theme={theme}>
        <BrowserRouter>
            {/* <React.StrictMode> */}
            <App />
            {/* </React.StrictMode> */}
        </BrowserRouter>
    </ThemeProvider>,
);
